var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145 28.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1,1h143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FEFEFE",
    d: "M71.1,12.3h1.6V13c0.2-0.4,1-0.9,1.8-0.9c1.7,0,2.1,0.9,2.1,2.5v3.2H75V15c0-0.7-0.4-1.4-1-1.4 c-0.7,0-1.2,0.6-1.2,1.6v2.6h-1.7C71.1,17.8,71.1,12.3,71.1,12.3z M68.2,17.8h1.6v-5.5h-1.6V17.8z M70.2,10.3c0,0.5-0.5,1-1,1 c-0.5,0-1.2-0.4-1.2-1s0.5-1,1-1S70.2,9.8,70.2,10.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M37.3,1.9c20.4,0,22.9,0.8,22.9,14.3c0,7.3,4.7,12.3,12,12.3c7.3,0,12-5,12-12.3C84.2,2.6,87,1.9,107,1.9 C107,1.9,37.3,1.9,37.3,1.9z M72.1,24.2c-6,0-10.7-4.9-10.7-10.7c0-6,4.9-10.7,10.7-10.7c5.8,0,10.7,4.9,10.7,10.7 S78.2,24.2,72.1,24.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.019dbe9a3a129796bd7e7a1df3f57ad7.svg";
export { ForwardRef as ReactComponent };